<div id="mini-search-box-element-wrapper"
     [hidden]="!showSearchBox"
>
  <v-form-with-input (keyupEvent)="inputSearchOnChange($event)"
                     (keyupEnterEvent)="startSearching()"
                     placeholderKey="minisearchbox.search.text"
  >
    <div class="a-search-button" (click)="startSearching()">
      <span>
        {{'wordSearch' | translate}}
      </span>
    </div>
  </v-form-with-input>

  <v-mini-search-result
    *ngIf="(searchBoxResponseObs | async) as searchResult"
    [searchResult]="searchResult"
    [showSearchResult]="showSearchResult"
    [urlToAllResult]="urlToAllResult"
    [hidden]="!showSearchResult"
    ></v-mini-search-result>
</div>




